import { useUserStore } from '@/stores/user.js'
import { useChatStore } from '@/stores/chat.js'
import { useDialogsStore } from '@/stores/dialogs.js'
import { useCreatorStore } from '@/stores/creator.js'
import { useFeedStore } from '@/stores/feed.js'
import { usePostStore } from '@/stores/post.js'
import { usePaymentStore } from '@/stores/payment.js'
import { useAuthStore } from '@/stores/auth.js'
import { useQuizStore } from '@/stores/quiz.js'
import { useCreatorsCatalogStore } from '@/stores/creatorsCatalog.js'
import { useTagsStore } from '@/stores/tags.js'


export default function () {
  const userStore = useUserStore()
  const chatStore = useChatStore()
  const dialogsStore = useDialogsStore()
  const creatorStore = useCreatorStore()
  const feedStore = useFeedStore()
  const postStore = usePostStore()
  const paymentStore = usePaymentStore()
  const quizStore = useQuizStore()
  const authStore = useAuthStore()
  const creatorsCatalogStore = useCreatorsCatalogStore()
  const tagsStore = useTagsStore()
  

  // Prepare needed actions for each socket event
  return new Map([
    ['session.start', [
      userStore.sessionStart,
      paymentStore.sessionStart,
      quizStore.sessionStart
    ]],
    ['messages.unread', [
      userStore.messagesUnread
    ]],
    ['dialogs.urgent.counts.changed', [
      userStore.urgentCountsChanged
    ]],
    ['attachment.status', [
      chatStore.attachmentStatus
    ]],
    ['message.status', [
      chatStore.messageStatus
    ]],
    ['dialog.status', [
      chatStore.dialogStatus,
      dialogsStore.dialogStatus
    ]],
    ['dialog.recommended', [
      dialogsStore.dialogRecommended
    ]],
    ['message.new', [
      chatStore.messageNew,
      dialogsStore.messageNew,
      creatorStore.messageNew,
      feedStore.messageNew,
      postStore.messageNew
    ]],
    ['user.changed', [
      userStore.userChanged
    ]],
    ['post.new', [
      postStore.postNew
    ]],
    ['user.status', [
      dialogsStore.userStatus,
      chatStore.dialogUserStatus,
      feedStore.userStatus,
      postStore.userStatus,
      creatorStore.userStatus,
      creatorsCatalogStore.userStatus,
      tagsStore.userStatus
    ]],
    ['user.lastSeen.sync', [
      dialogsStore.userLastSeenSync,
      chatStore.userLastSeenSync,
      feedStore.userLastSeenSync,
      postStore.userLastSeenSync,
      creatorStore.userLastSeenSync,
      creatorsCatalogStore.userLastSeenSync,
      tagsStore.userLastSeenSync
    ]],
    ['dialog.sync', [
      dialogsStore.dialogSync,
      chatStore.dialogSync
    ]],
    ['post.purchase', [
      creatorStore.postPurchase,
      feedStore.postPurchase
    ]],
    ['message.deleted', [
      chatStore.messageDeleted,
      dialogsStore.messageDeleted
    ]],
    ['survey.changed', [
      quizStore.surveyChanged
    ]],
    ['purchase.settled', [
      paymentStore.purchaseSettled
    ]],
    ['user.sync', [
      dialogsStore.userSync,
      chatStore.userSync
    ]],
    ['creditsPricing.sync', [
      paymentStore.creditsPricingSync
    ]],
    ['currentPaymentMethod.sync', [
      paymentStore.currentPaymentMethodSync
    ]],
    ['dialog.sync', [
      chatStore.dialogSync
    ]],
    ['messageBlur.sync', [
      authStore.messageBlurSync
    ]]
  ])
}
